module.exports = __webpack_public_path__ + "img/yamaka.90106947.png";